import $api from 'http'
import $apiJSON from 'http/apiJSON'



// ── Категории ───────────────────────────────────────────────────────────────

export const getDocumentCategories = () =>
    $apiJSON.get(`komurconnection/categories/`)

// ── НПА ─────────────────────────────────────────────────────────────────────

export const getNPAList = () =>
    $apiJSON.get(`komurconnection/npa/`)

export const getNPADetail = (id) =>
    $apiJSON.get(`komurconnection/npa/${id}/`)

/** Upload new NPA (multipart form data). */
export const createNPA = (formData) =>
    $api.post(`komurconnection/npa/`, formData, { headers: { 'Content-Type': undefined } })

export const updateNPA = (id, data) =>
    $apiJSON.patch(`komurconnection/npa/${id}/`, data)

export const deleteNPA = (id) =>
    $apiJSON.delete(`komurconnection/npa/${id}/`)

/** Increments download_count and returns { file_url }. */
export const downloadNPA = (id) =>
    $apiJSON.post(`komurconnection/npa/${id}/download/`)

// ── Мои документы ───────────────────────────────────────────────────────────

export const getMyDocuments = () =>
    $apiJSON.get(`komurconnection/my-documents/`)

export const getMyDocumentDetail = (id) =>
    $apiJSON.get(`komurconnection/my-documents/${id}/`)

/** Upload a new document (multipart form data, fields: file, title, description). */
export const uploadDocument = (formData) =>
    $api.post(`komurconnection/my-documents/`, formData, { headers: { 'Content-Type': undefined } })

/** Rename / update description of an owned document. */
export const updateDocument = (id, data) =>
    $apiJSON.patch(`komurconnection/my-documents/${id}/`, data)

export const deleteDocument = (id) =>
    $apiJSON.delete(`komurconnection/my-documents/${id}/`)

/** Increments download_count and returns { file_url }. */
export const downloadDocument = (id) =>
    $apiJSON.post(`komurconnection/my-documents/${id}/download/`)

/**
 * Toggle a visibility flag on a document the user owns.
 * @param {number} id - document id
 * @param {'is_open'|'show_in_dept'|'show_in_transit'} flag
 */
export const toggleDocumentFlag = (id, flag) =>
    $apiJSON.patch(`komurconnection/my-documents/${id}/toggle/${flag}/`)

// ── Отдел ────────────────────────────────────────────────────────────────────

/** Documents shared to the requesting user's department (show_in_dept=True). */
export const getDeptDocuments = () =>
    $apiJSON.get(`komurconnection/dept-documents/`)

// ── Транзит ──────────────────────────────────────────────────────────────────

/** All documents visible to all employees (show_in_transit=True). */
export const getTransitDocuments = () =>
    $apiJSON.get(`komurconnection/transit/`)

// ── Кыргызкомур иерархия ────────────────────────────────────────────────────

/** All departments with document count summaries. */
export const getKyrgyzkomur = () =>
    $apiJSON.get(`komurconnection/kyrgyzkomur/`)

/** Department detail: employees + their open docs + dept docs. */
export const getKyrgyzkomurDept = (deptId) =>
    $apiJSON.get(`komurconnection/kyrgyzkomur/${deptId}/`)
